export const bigIntParser = (
    val: null | undefined | string | number | bigint
): bigint | null => {
    if (val === null || val === undefined) {
        return null;
    }

    return BigInt(val);
};
